export default __webpack_public_path__ + "static/media/nokia-logo.08e2907f.svg";